<div class="flex-container gap-6" style="height: 100%">
  <vl-widget-title
    [text]="'stats.evolution_prix_achat' | trans"
    [widget]="widget()"
    [draggable]="false"
    [editable]="false"
    [filter]="true"
  >
    <ng-content class="drag-handler" select=".drag-handler"></ng-content>

    <!-- Bouton filtre dans le header -->
    <ng-content class="filter" select=".filter">
      <vl-chips
        size="small"
        iconLeft="settings"
        (action)="trigger.attachOverlay()"
        [popoverTrigger]="filters"
        #trigger="popoverElement"
        [closeOnClickOutside]="true"
        state="enabled"
      >
        {{ 'button.filter' | trans }}
      </vl-chips>
    </ng-content>
  </vl-widget-title>

  <!-- Popover des filtres -->
  <ng-template #filters>
    <div class="flex-col w100 gap-8 justup-card p-8 up-3">
      <div class="flex" style="gap:.75rem; align-items:center; flex-wrap:wrap">
        <div class="caption-2 on-background-alt">
          Top {{ topCount() }} / {{ maxRows() }}
        </div>
        <input
          type="range"
          [min]="1"
          [max]="Math.max(1, maxRows())"
          [value]="topCount()"
          (input)="topCount.set(($any($event.target).valueAsNumber)||1)"
          [disabled]="maxRows() <= 1"
          style="width:180px"
          aria-label="Limiter le nombre de commandes (les plus récentes)"
        />
        <div class="search-wrap" style="display:flex;align-items:center;gap:.4rem;">
          <span class="caption-2 on-background-alt">Filtrer :</span>
          <input
            type="search"
            [value]="search()"
            (input)="search.set(($any($event.target).value||'').toString())"
            [placeholder]="'stats.commande_placeholder' | trans"
            class="ju-input"
            style="height:28px;padding:0 .5rem; min-width:200px"
            aria-label="Filtrer par numéro de commande"
          />
        </div>
      </div>
    </div>
  </ng-template>

  @if (metadata()?.loading) {
    <div class="h100 flex-row gap-16 widget-content">
      <div class="h100 w100 overflow-hidden">
        <ngx-skeleton-loader count="1" [theme]="{ height: '260px', 'background-color': 'var(--color-on-disabled)' }"/>
      </div>
    </div>
  } @else {
    @if (pointsTop().length) {
      <div class="canvas-wrap w100 widget-content fade-in">
        <canvas #articleAchat style="width:100%; display:block;"></canvas>
      </div>
    } @else {
      <div class="widget-content empty">
        <div class="caption on-disabled">{{ 'filters.no_data' | trans }}</div>
      </div>
    }
  }
</div>
